import { useEffect, useState } from "react";
import { posthog } from "./posthog";

// Subscribes to a PostHog feature flag and returns its current boolean state.
// Returns `false` until flags have loaded, so callers can treat undefined and
// false identically — the safer default is "feature off."
export function useFeatureFlag(key: string): boolean {
  const [enabled, setEnabled] = useState<boolean>(() => {
    const v = posthog.isFeatureEnabled(key);
    return v === true;
  });

  useEffect(() => {
    const unsubscribe = posthog.onFeatureFlags(() => {
      setEnabled(posthog.isFeatureEnabled(key) === true);
    });
    return () => {
      unsubscribe?.();
    };
  }, [key]);

  return enabled;
}
